export enum EmailOptInFieldTypes {
  PROMPT = 'prompt',
  MESSAGE = 'message',
  AUTO_SELECT_FOR_DONOR = 'autoSelectForDonor'
}
